import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aaf1eff8")

_pushScopeId("data-v-aaf1eff8")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "pi pi-cloud-upload" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (!_ctx.isShow)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        id: "layout-config",
        class: { 'layout-config-active': !_ctx.isShow }
      }, [
        _createVNode("a", {
          id: "layout-config-button",
          class: ["layout-config-button", { running: _ctx.isHavingTask(), not_runing: !_ctx.isHavingTask() }],
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onTaskButtonClick($event)))
        }, [
          _hoisted_1
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
})